import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicHazards = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Hazards in Pipelining: Types, Prevention, and Drawbacks"
      videos={[
        "https://www.youtube.com/embed/srlgaJgaxRE",
        "https://www.youtube.com/embed/3bkgwvfQSNQ",
        "https://www.youtube.com/embed/OTvi_NCQw2Y",
        "https://www.youtube.com/embed/Nj_WUF_zBaY?list=PLgwJf8NK-2e5CsijAZszH0wO-A298XKLx"
      ]}
      takeaways={[
        { text: "Understand all types of hazards: Data, Control, and Structural." },
        { text: "Analyze methods to prevent and resolve hazards along with their drawbacks." },
        { text: "Practice application-based questions on hazard resolution techniques." }
      ]}
      questions={[
        
      ]}
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicHazards;
